/**
 * Filtering Plugin Styles
 *
 * Scoped to tbw-grid using CSS nesting for light DOM compatibility.
 */
@layer tbw-plugins {
  tbw-grid {
    /* Quick filter input in header */
    .tbw-quick-filter-input {
      flex: 1;
      max-width: 300px;
      height: var(--tbw-input-height, 1.75rem);
      padding: var(--tbw-input-padding, 0 0.5rem);
      border: 1px solid var(--tbw-color-border);
      border-radius: var(--tbw-border-radius);
      background: var(--tbw-color-bg);
      color: var(--tbw-color-fg);
      font-size: var(--tbw-font-size-sm, 0.8125rem);

      &:focus {
        outline: none;
        border-color: var(--tbw-color-accent);
      }
    }

    /* Header cell indicator when filtered */
    .header-cell.filtered::before {
      content: '';
      position: absolute;
      top: var(--tbw-spacing-xs, 0.25rem);
      right: var(--tbw-spacing-xs, 0.25rem);
      width: var(--tbw-indicator-size, 0.375rem);
      height: var(--tbw-indicator-size, 0.375rem);
      background: var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6));
      border-radius: 50%;
    }

    .tbw-filter-btn {
      display: var(--tbw-filter-btn-display, inline-flex);
      visibility: var(--tbw-filter-btn-visibility, visible);
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 2px;
      margin-left: var(--tbw-spacing-xs, 0.25rem);
      opacity: 0.4;
      transition:
        opacity 0.15s,
        visibility 0s,
        display 0s allow-discrete;
      color: inherit;
      vertical-align: middle;
      transition-behavior: allow-discrete;

      &:hover,
      &.active {
        opacity: 1;
        visibility: visible;
        display: inline-flex;
      }

      &.active {
        color: var(--tbw-filter-accent, var(--tbw-color-accent, #3b82f6));
      }
    }

    /* Show filter button on header cell hover or when filtered */
    .header-row .cell:hover .tbw-filter-btn,
    .header-row .cell.filtered .tbw-filter-btn {
      display: inline-flex;
      visibility: visible;
    }

    /* Coarse pointer (touch): filter button always visible and large enough to tap */
    @media (hover: none) {
      .header-row .cell .tbw-filter-btn {
        display: inline-flex;
        visibility: visible;
      }
    }

    /* WCAG 2.2 SC 2.5.8 Target Size (Minimum) is not pointer-conditional — the
       button carries its 24px target on a mouse too. It sits in a ~30px header,
       so this costs 4px of label width and no height. */
    .tbw-filter-btn {
      min-width: var(--tbw-touch-target-min, 24px);
      min-height: var(--tbw-touch-target-min, 24px);
    }
  }
} /* End @layer tbw-plugins */
